import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import {
  GetServiceQuery,
  GetServiceResponse,
} from '@hud/portal-dtos/webapp-service.dto';
import { AxiosError } from 'axios';
import { ErrorResponse } from '@hud/portal-dtos/src/lib/webapp-common.dto';
import { PORTAL_BASE } from '../consts';

export const SERVICE_ID = 'service';

export default function useService(
  serviceId?: number,
  params?: GetServiceQuery,
) {
  const { client, isReady } = useClient();
  return useQuery<GetServiceResponse, AxiosError<ErrorResponse>>({
    queryKey: [SERVICE_ID, serviceId, params],
    queryFn: async () => {
      const response = await client.get<GetServiceResponse>(
        `${PORTAL_BASE}/services/${serviceId}`,
        { params },
      );
      return GetServiceResponse.parse(response.data);
    },
    enabled: serviceId !== undefined && isReady,
    retry: (failureCount, error) => {
      if (
        error?.response?.status &&
        error.response.status > 401 &&
        error.response.status < 500
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
